import { jsx as _jsx } from "react/jsx-runtime";
import LocationAutocompleteMobile from "./variants/autocomplete/index.js";
import LocationSelectMobile from "./variants/select/index.js";
export const LocationMobile = (props)=>{
    const { variant ='autocomplete'  } = props;
    if (variant === 'autocomplete') {
        const typedProps = props;
        return /*#__PURE__*/ _jsx(LocationAutocompleteMobile, {
            ...typedProps
        });
    }
    if (variant === 'select') {
        const typedProps = props;
        return /*#__PURE__*/ _jsx(LocationSelectMobile, {
            ...typedProps
        });
    }
    return null;
};
export default LocationMobile;

//# sourceMappingURL=index.js.map